module.exports = __webpack_public_path__ + "static/media/sales-amount-svgrepo-com.615f433a.svg";